import {useTranslation} from 'react-i18next'
import {SidebarLink} from '@/components/sidebar-link'
import {SidebarSection} from '@/components/sidebar-section'

export function AdminConsoleNav() {
  const {t} = useTranslation()
  return (
    <>
      <SidebarSection id="admin-operacion" context="admin" label={t('nav.sectionAdminOperacion')}>
        <SidebarLink to="/" end testId="nav-admin-atencion">
          {t('nav.atencion')}
        </SidebarLink>
        <SidebarLink to="/admin/empresas" testId="nav-admin-empresas">
          {t('nav.businesses')}
        </SidebarLink>
        <SidebarLink to="/admin/partners" testId="nav-admin-partners">
          {t('nav.partners')}
        </SidebarLink>
        <SidebarLink to="/admin/sst" testId="nav-admin-sst">
          {t('solicitudesSst.nav.section')}
        </SidebarLink>
      </SidebarSection>

      <SidebarSection id="admin-servicios" context="admin" label={t('nav.sectionAdminServicios')}>
        {/* Función de Inci como IPS (Res. 2764/2022 art. 5): la empresa es el sujeto, no un tenant. */}
        <SidebarLink to="/admin/bateria" testId="nav-admin-bateria">
          {t('admin.bateria.nav.section')}
        </SidebarLink>
        <SidebarLink to="/admin/bateria-solicitudes" testId="nav-admin-bateria-solicitudes">
          {t('bateriaSolicitudes.nav.section')}
        </SidebarLink>
        <SidebarLink to="/admin/licencias">{t('licencia.nav.adminQueue')}</SidebarLink>
      </SidebarSection>

      <SidebarSection id="admin-plataforma" context="admin" label={t('nav.sectionAdminPlataforma')}>
        <SidebarLink to="/admin/cartera" testId="nav-admin-cartera">
          {t('cartera.nav')}
        </SidebarLink>
        <SidebarLink to="/admin/valores-economicos" testId="nav-admin-valores-economicos">
          {t('valoresEconomicos.nav')}
        </SidebarLink>
        <SidebarLink to="/admin/catalogo" testId="nav-admin-catalogo">
          {t('adminCatalogo.nav')}
        </SidebarLink>
        {/* KAI-158: hay cuentas sin correo a las que «¿Olvidó su contraseña?» no alcanza. */}
        <SidebarLink to="/admin/usuarios" testId="nav-admin-usuarios">
          {t('nav.usuarios')}
        </SidebarLink>
        <SidebarLink to="/admin/admins" testId="nav-admin-admins">
          {t('nav.admins')}
        </SidebarLink>
      </SidebarSection>
    </>
  )
}
